<template>
  <div class="promo-test-card-bg p-2">
    <p class="promo-test-card-title">{{ title.toUpperCase() }}</p>
    <div v-for="node in testNodeList" :key="node.id">
      <PromoTestTreeNode 
        :class="node === testNodeList[0] ? 'mt-1.5' : 'mt-3'" 
        :test-node="node"
        :remaining-quantity="remainingQuantity"
        :select-prop="selectProp"
        :is-not-allowed-select-prop="isNotAllowedSelectProp"
        :order-test-support-obj="orderTestSupportObj"
        :selected-vw-test-price="selectedVwTestPrice"
        :disabled-x-choose-y-panel-test-ids="disabledXChooseYPanelTestIds"
      />
    </div>
  </div>
</template>

<script>
import PromoTestTreeNode from './PromoTestTreeNode.vue';
export default {
  components: {
    PromoTestTreeNode
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    testNodeList: {
      type: Array,
      default: () => []
    },
    remainingQuantity: {
      type: Number,
      default: 0
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },    
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },
    selectedVwTestPrice: {
      type: Number,
      default: 0
    },
    disabledXChooseYPanelTestIds: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.promo-test-card-bg {
  background-color: #F9FBFD;
}
.promo-test-card-title {
  /* font-family: IBM Plex Sans Hebrew; */
  font-size: 12px;
  font-weight: 600;
  line-height: 15.6px;
  color: #979797;
}
</style>